import { MetaEntry, WorkflowConfig } from '../lib/types'
import Alert from '../components/alert'
import Tag from '../components/tag'
import { Information } from '@carbon/icons-react'

type Props = {
    config: WorkflowConfig
    meta: MetaEntry,
    onClickShowHistory: () => void
}

export default function MetaSummary(props: Props) {
    const { config, meta, onClickShowHistory } = props

    let statusColor = 'gray'
    let status = 'No Changes'

    if (new Date(meta.reviewFinished) > config.start) {
        if (meta.error) {
            statusColor = 'red'
            status = 'Error Found'
        } else {
            statusColor = 'blue'
            status = 'Changes Made'
        }
    }

    return (
        <Alert>
            <div>
                <i className='lni lni-tag' /> <span className='font-medium mr-3'>Status:</span>
                <Tag color={statusColor}>{status}</Tag>
            </div>
            <div className='mt-3'>
                <i className='lni lni-calendar' />{' '}
                <span className='font-medium mr-3'>Last Updated:</span>
                {meta.reviewFinished
                    ? new Date(meta.reviewFinished).toLocaleString()
                    : 'Not updated'}
            </div>
            <div className='mt-3'>
                <i className='lni lni-user' /> <span className='font-medium mr-3'>Updated By:</span>
                {meta.username || meta.accountId || 'None'}
            </div>
            {meta.notes && (
                <div className='flex mt-2 justify-between items-center'>
                    <div>
                        <i className='lni lni-comments' />{' '}
                        <span className='font-medium mr-3'>Last Note:</span>
                        {meta.notes}
                    </div>
                    <button onClick={onClickShowHistory} className="text-blue-600 focus:outline-none flex items-center">
                        <Information className='mr-2' /> Show History
                    </button>
                </div>
            )}
        </Alert>
    )
}
